/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useFeatureFlag } from "../../../../services/firebase/remote-config/useFeatureFlag";

import { DeprecatedShopProductCard } from "./DeprecatedShopProductCard";
import { ShopProductCard, type ShopProductCardProps } from "./ShopProductCard";

export const ShopProductCardSwitch = (props: ShopProductCardProps) => {
  const enableShopCartPage = useFeatureFlag("enableShopCartPage");

  return enableShopCartPage ? (
    <ShopProductCard {...props} />
  ) : (
    <DeprecatedShopProductCard {...props} />
  );
};
